import React from 'react';
import FormField from '../../../../../components/common/FormField';
import BasicLabel from '../../../../../components/common/BasicLabel';
import { FormInput } from '../../../../../components/common/FomInput/FormInput';
import SelectField from '../../../../../components/common/SelectField';
import AdminFormWrap from '../AdminFormWrap/AdminFormWrap';

import { ADMIN_LEVEL_TYPE_LIST, ADMIN_STATUS_TYPE_LIST } from '../../common/constants';

const AccountAdminCreateForm = (): JSX.Element => {
  return (
    <AdminFormWrap>
      <FormField label={<BasicLabel label={'이메일'} isRequired={true} />}>
        <FormInput id="email" name="email" label="email" limit={100} editable={true} required={true} />
      </FormField>
      <FormField label={<BasicLabel label={'이름'} isRequired={true} />}>
        <FormInput id="name" name="name" label="name" limit={50} editable={true} required={true} />
      </FormField>
      <FormField label={<BasicLabel label={'핸드폰 번호'} isRequired={true} />}>
        <FormInput id="phone" name="phone" label="phone" editable={true} required={true} />
      </FormField>
      <FormField label={<BasicLabel label={'비밀번호'} isRequired={true} />}>
        <FormInput id="password" name="password" label="password" editable={true} required={true} />
      </FormField>
      <FormField label={<BasicLabel label={'비밀번호 확인'} isRequired={true} />}>
        <FormInput
          id="passwordConfirm"
          name="passwordConfirm"
          label="passwordConfirm"
          editable={true}
          required={true}
        />
      </FormField>
      <FormField label={<BasicLabel label={'권한레벨'} isRequired={false} />}>
        <SelectField id="level" name="level" options={ADMIN_LEVEL_TYPE_LIST} editable={true} isRequired={false} />
      </FormField>
      <FormField label={<BasicLabel label={'관리자 상태'} isRequired={false} />}>
        <SelectField id="status" name="status" options={ADMIN_STATUS_TYPE_LIST} editable={true} isRequired={false} />
      </FormField>
    </AdminFormWrap>
  );
};

export default AccountAdminCreateForm;
